<template src="./template.html"></template>

<script>
export default {
  name: "HomeParallax",
  data() {
    return {}
  },
  methods: {},
  created() { }
}
</script>